import { Helmet } from 'react-helmet'

// Hooks
import { useTheme } from 'modules/profile/hooks'

const ThemeHelper = ({ theme: propsTheme }: { theme?: string }) => {
  const savedTheme = useTheme()
  const theme = propsTheme || savedTheme

  const attrs: { 'data-theme'?: string } = {}
  if (theme && ['light', 'dark'].includes(theme)) {
    attrs['data-theme'] = theme
  }

  return (
    <Helmet>
      <body {...attrs} />
    </Helmet>
  )
}

export default ThemeHelper
